module.exports = __webpack_public_path__ + "img/oao-iadops-logo-with-blue-divider.ca434754.png";